var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoatRegistration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "214px",
    height: "134px",
    viewBox: "0 0 214 134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "152DE897-4CCC-48F6-BE6D-4A50257C1CA5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02_Wallet_L_1440_Full",
    transform: "translate(-445.000000, -937.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vehicle-Registrations",
    transform: "translate(64.000000, 782.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Registered-Boat",
    transform: "translate(336.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boat-Registration-Card",
    transform: "translate(45.000000, 83.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#304FFE",
    x: 0,
    y: 0,
    width: 214,
    height: 134,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7098933,84.5210171 L62.0342933,84.5210171 C60.90136,84.5210171 59.9828267,83.6034121 59.9828267,82.4716237 L59.9828267,42.0997992 C59.9828267,41.1452982 60.6424267,40.3170694 61.5736267,40.1028861 C62.5046933,39.8884364 63.46056,40.3446415 63.8786933,41.2027068 L83.5542933,81.5746644 C83.8638933,82.2097553 83.8240267,82.9593969 83.4490933,83.5583909 C83.0742933,84.1572518 82.4170933,84.5210171 81.7098933,84.5210171",
    id: "Mask",
    fill: "#243ACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,84.5210171 L62.0342933,84.5210171 C60.9917239,84.5210171 60.1307169,83.7439526 60,82.7379967 L60,41.8342984 C60.1092727,40.9949703 60.7299876,40.2969297 61.5736267,40.1028861 C62.5046933,39.8884364 63.46056,40.3446415 63.8786933,41.2027068 L68,49.6591309 L68,84.5210171 Z",
    id: "Combined-Shape",
    fill: "#1C2CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.03372,84.5210171 L37.4598533,84.5210171 C36.7527867,84.5210171 36.09532,84.1572518 35.72052,83.5582577 C35.3454533,82.9592637 35.3058533,82.2097553 35.61532,81.5745312 L60.18932,31.1523409 C60.6075867,30.2942756 61.5638533,29.8386033 62.4943867,30.052387 C63.4254533,30.2667035 64.0851867,31.0949323 64.0851867,32.0493002 L64.0851867,82.4716237 C64.0851867,83.6034121 63.1666533,84.5210171 62.03372,84.5210171",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3538933,98.1976744 L54.0550933,98.1976744 C48.8620267,98.1976744 43.7328267,96.8393153 39.2220267,94.2689822 C34.7112267,91.6986492 30.9294933,87.9800111 28.28576,83.5150614 C27.91056,82.8814358 27.9044267,82.0955641 28.2694933,81.4562109 C28.6344267,80.8171241 29.3148267,80.4224567 30.0514933,80.4224567 L91.8536267,80.4224567 C92.5010933,80.4224567 93.11056,80.7277479 93.49776,81.2460236 C93.8848267,81.7645657 94.0044267,82.4350873 93.8198933,83.0551267 L92.4392267,87.6988289 C91.53056,90.7544044 89.6984267,93.3773509 87.1408267,95.2838222 C84.5834933,97.1902935 81.54496,98.1976744 78.3538933,98.1976744",
    id: "Fill-5",
    fill: "#1C2CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,42 L179,42 C180.656854,42 182,43.3431458 182,45 C182,46.6568542 180.656854,48 179,48 L115,48 C113.343146,48 112,46.6568542 112,45 C112,43.3431458 113.343146,42 115,42 Z M115,64 L179,64 C180.656854,64 182,65.3431458 182,67 C182,68.6568542 180.656854,70 179,70 L115,70 C113.343146,70 112,68.6568542 112,67 C112,65.3431458 113.343146,64 115,64 Z M115,86 L179,86 C180.656854,86 182,87.3431458 182,89 C182,90.6568542 180.656854,92 179,92 L115,92 C113.343146,92 112,90.6568542 112,89 C112,87.3431458 113.343146,86 115,86 Z",
    id: "Combined-Shape",
    fill: "#243ACB",
    fillRule: "nonzero"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatRegistration);
export default __webpack_public_path__ + "static/media/boat-registration.c6fda872645c3072e6fc99f0a98f7fe1.svg";
export { ForwardRef as ReactComponent };